import { render, staticRenderFns } from "./DevicePoC22.vue?vue&type=template&id=1a85e7e2&"
import script from "./DevicePoC22.vue?vue&type=script&lang=js&"
export * from "./DevicePoC22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports